import { IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

interface BackButtonProps {
  onClick: () => void;
  'aria-label'?: string;
}

export function BackButton({ onClick, 'aria-label': ariaLabel }: BackButtonProps) {
  return (
    <IconButton
      onClick={onClick}
      aria-label={ariaLabel}
      size="small"
      sx={{
        width: 32,
        height: 32,
        borderRadius: '50%',
        bgcolor: '#17171C',
        border: '1px solid #676774',
        color: 'white',
        '&:hover': { bgcolor: '#27272E' },
      }}
    >
      <ArrowBackIcon sx={{ fontSize: 16 }} />
    </IconButton>
  );
}
